import { FC, useContext } from 'react';
import { FunctionalDynamicAssessmentContext } from '../context';
import { FDAMeshViewer } from './FDAMeshViewer';

import {
  BalanceGaitSwitcher,
  FDAMeshViewerControls,
  // CameraFollowButton,
} from './FDAMeshViewerControls';
import { styled, Typography } from '@mui/material';

export const noDataContainer = () => {
  return (
    <NoDataContainer>
      <Typography variant='h4'>No data available</Typography>
    </NoDataContainer>
  );
};

export const BalanceMeshViewerContainer: FC = () => {
  const { balanceControls, balanceData } = useContext(
    FunctionalDynamicAssessmentContext
  );

  // Check if we have a valid output stream URL
  const hasDataUrl = Boolean(balanceData?.output_stream);

  return (
    <div>
      <FDAMeshViewerContainer>
        <BalanceGaitSwitcher />
        {hasDataUrl ? (
          <>
            <FDAMeshViewer
              setAnimationContext={balanceControls.setAnimationContext}
              setCurrentFrame={balanceControls.setCurrentFrame}
              animations={balanceControls.animations}
              nodes={balanceControls.nodes}
            />
            <FDAMeshViewerOverlayControls>
              <FDAMeshViewerControls
                playPause={balanceControls.playPause}
                isPlaying={balanceControls.isPlaying}
                currentFrame={balanceControls.currentFrame}
                changeTimeScale={balanceControls.changeTimeScale}
                totalFrames={balanceControls.totalFrames}
                seek={balanceControls.seek}
                seekStart={balanceControls.seekStart}
                seekEnd={balanceControls.seekEnd}
              />
            </FDAMeshViewerOverlayControls>
          </>
        ) : (
          noDataContainer()
        )}
      </FDAMeshViewerContainer>
    </div>
  );
};

export const GaitMeshViewerContainer: FC = () => {
  const { gaitControls, gaitData, cameraFollow } = useContext(
    FunctionalDynamicAssessmentContext
  );

  // Check if we have a valid output stream URL
  const hasDataUrl = Boolean(gaitData?.output_stream);

  return (
    <div>
      <FDAMeshViewerContainer>
        <BalanceGaitSwitcher />
        {/* <CameraFollowButton /> */}
        {hasDataUrl ? (
          <>
            <FDAMeshViewer
              setAnimationContext={gaitControls.setAnimationContext}
              setCurrentFrame={gaitControls.setCurrentFrame}
              animations={gaitControls.animations}
              nodes={gaitControls.nodes}
              cameraFollow={cameraFollow}
            />
            <FDAMeshViewerOverlayControls>
              <FDAMeshViewerControls
                playPause={gaitControls.playPause}
                isPlaying={gaitControls.isPlaying}
                currentFrame={gaitControls.currentFrame}
                changeTimeScale={gaitControls.changeTimeScale}
                totalFrames={gaitControls.totalFrames}
                seek={gaitControls.seek}
                seekStart={gaitControls.seekStart}
                seekEnd={gaitControls.seekEnd}
              />
            </FDAMeshViewerOverlayControls>
          </>
        ) : (
          noDataContainer()
        )}
      </FDAMeshViewerContainer>
    </div>
  );
};

const FDAMeshViewerContainer = styled('div')`
  position: relative;
  background-color: lightgray;
  border-radius: 16px;
`;

const FDAMeshViewerOverlayControls = styled('div')`
  position: absolute;
  bottom: 12px;
  width: 100%;
`;

const NoDataContainer = styled('div')`
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
`;
